/**
 * Edit Feature Request Route Definition (Non-Lazy)
 *
 * Def only — the page (and the feature-request form stack it drags in:
 * @tanstack/react-form, sonner, the bottom-sheet) lives in the .lazy sibling.
 * As a non-lazy component this route hoisted all of it into the entry chunk.
 */
import { createFileRoute } from '@tanstack/react-router';
import { FormPageTemplatePending } from '@/components/v2/page-template-pending';
import { v2 } from '@/lib/i18n/v2';

export const Route = createFileRoute('/_authenticated/feature-requests/edit/$featureRequestId')({
  // Template-first pending while the form chunk downloads (first visit), with
  // the loaded page's real title strings so nothing swaps text on arrival.
  // The edit form navigates back with an arrow (headerVariant="back") and
  // submits from the sticky BottomAction bar.
  pendingComponent: () => (
    <FormPageTemplatePending
      title={`${v2.featureRequestFormEdit.title} ${v2.featureRequestFormEdit.titleAccent}`}
      subtitle={v2.featureRequestFormEdit.subtitle}
      variant="arrow"
      cta
    />
  ),
});
